"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const conversionUtils_1 = require("../../conversionUtils");
const operationConvertors_1 = require("../../operationConvertors");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_generatedLoanTape.isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    const { id, creditFacilitySlug, loanProductSlug, artifactSlug } = tape;
    const { externalReceivableId, rawMasterLoanTapeArtifactSlug, rawExternalReceivableIdField, externalAssignmentField, signaledAssignmentValueMapping, loanTapeType, ...task } = tape.configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            externalReceivableId,
            artifactSlug,
            creditFacilitySlug,
            loanProductSlug,
            rawMasterLoanTapeArtifactSlug: rawMasterLoanTapeArtifactSlug || null,
            rawExternalReceivableIdField: rawExternalReceivableIdField || null,
            externalAssignmentField: externalAssignmentField || null,
            signaledAssignmentValueMapping: signaledAssignmentValueMapping || [],
            loanTapeType,
        },
    };
    const operationNode = (0, operationConvertors_1.taskToOperationNode)({
        task,
    });
    return {
        operationNode,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_1.file_generatedLoanTape.isNode(node), `uiNodesToIntermediate: node is not a ${types_1.artifactType} node: ${node.metadata.tapeBuilderNodeType}`);
    const { tapeBuilderNodeId } = node.metadata;
    const { artifactSlug, creditFacilitySlug, loanProductSlug, externalReceivableId, rawMasterLoanTapeArtifactSlug, rawExternalReceivableIdField, externalAssignmentField, signaledAssignmentValueMapping, loanTapeType, } = node.configuration;
    const { operationNode, task: configuration } = (0, conversionUtils_1.getNativeOperationTask)({
        node,
        graph,
    });
    const record = {
        id: tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug,
        externalFilename: null,
        configuration: {
            ...configuration,
            externalReceivableId,
            rawMasterLoanTapeArtifactSlug,
            rawExternalReceivableIdField,
            externalAssignmentField,
            signaledAssignmentValueMapping,
            loanTapeType,
        },
    };
    return {
        record,
        operationNode,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map